// URL search params of the Engineering BOMs page (PX-ENG-110). Kept apart from
// the page module so the route config (entry chunk) does not pull the page in.
import { engineeringBomListColumns } from "@patronix/domain/list";
import { viewSearch, type ViewSearch } from "@/lib/listView";
import { ebomFilters, type EbomFilter } from "./api";

export interface EbomSearch extends ViewSearch {
  status: EbomFilter;
  q: string;
  id?: string | undefined;
  /** The import panel is open (replaces the detail). */
  import?: true | undefined;
}

export function validateEbomSearch(raw: Record<string, unknown>): EbomSearch {
  const s: EbomSearch = {
    status: ebomFilters.includes(raw.status as EbomFilter) ? (raw.status as EbomFilter) : "current",
    q: typeof raw.q === "string" ? raw.q.slice(0, 100) : "",
  };
  if (typeof raw.id === "string" && raw.id) s.id = raw.id;
  if (raw.import === true || raw.import === "true") s.import = true;
  return { ...s, ...viewSearch(engineeringBomListColumns, raw) };
}
